export default __webpack_public_path__ + "static/media/pasta.fbf54eb8.jpg";